import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Snackbar } from "@mui/material";
import { usePasswordReset } from "../../hooks/employees";
import makeStyles from "@mui/styles/makeStyles";
import Alert from "@mui/material/Alert";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import { Tooltip } from "../../components/Tooltip";

const useStyles = makeStyles(theme => {
  return {
    send: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "&:hover, &:focus": {
        background: theme.palette.primary.dark
      }
    }
  };
});

const PasswordResetButton = ({ email, emailBlocked, disabled, employeeID }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [emailStatus, setEmailStatus] = useState();
  const sendPasswordReset = usePasswordReset(employeeID);
  const { send } = useStyles();
  const sendPasswordResetTooltip = emailBlocked
    ? t("employeeDetail.blockedTooltip")
    : !email
    ? t("employeeDetail.notAvailableTooltip")
    : disabled && t("employeeDetail.disabledTooltip");

  const handlePasswordReset = async () => {
    // Password Reset Call
    const status = await sendPasswordReset();
    // Show success or failure
    if (status.message === "Success") {
      setEmailStatus(<Alert serverity="success">{status.message}</Alert>);
    } else {
      setEmailStatus(<Alert serverity="error">{status.message}</Alert>);
    }
    setOpen(true);
  };

  return (
    <>
      <ButtonGroup alignSelf="flex-start">
        <Tooltip title={sendPasswordResetTooltip || ""}>
          <span>
            <Button
              color="primary"
              variant="contained"
              className={send}
              disabled={disabled || emailBlocked || !email}
              onClick={handlePasswordReset}
            >
              {t("employeeDetail.sendPasswordReset")}
            </Button>
          </span>
        </Tooltip>
      </ButtonGroup>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        {emailStatus}
      </Snackbar>
    </>
  );
};

export default PasswordResetButton;
